import axios, { AxiosInstance, AxiosResponse, AxiosError } from "axios";
import { getDecryptedToken } from "../utils/crypto/cryptoUtils";

const companyApiClient: AxiosInstance = axios.create({
  baseURL: process.env.REACT_APP_API,
  headers: {
    "Content-Type": "application/json; charset=utf-8",
  },
});

companyApiClient.interceptors.request.use((config) => {
  const token = getDecryptedToken("company_token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

companyApiClient.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => {
    if (error.response?.status === 401) {
      window.location.href = "/company-login";
    }
    return Promise.reject(error);
  },
);

export default companyApiClient;
